import { connect } from 'react-redux';
import { searchSelectors, contactSelectors, currentUserSelectors } from '@lifesize/nucleus';
import ModeratorSearch from 'components/ModeratorSearch/ModeratorSearch';
import { MEETING_FORM } from 'components/ContactModal/MeetingForm';
import { MODERATOR_LABEL } from 'components/ModeratorSearch/ModeratorSearchBar';
import actions from 'actions/ContactModal';
import { change } from 'redux-form';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _reject from 'lodash/reject';

const searchResults = [];

const mapDispatchToProps = dispatch => ({
  handleSelectContact: (contact) => {
    dispatch(actions.setModerator(contact));
    dispatch(actions.setModeratorFormFocus(false));
  },
  handleSetIsFocused: (isFocused) => {
    dispatch(actions.setModeratorFormFocus(isFocused));
  },
  handleResetContact: () => {
    dispatch(actions.unsetModerator());
  },
  handleEnter: (selectedContact) => {
    dispatch(change(MEETING_FORM, MODERATOR_LABEL, selectedContact));
    dispatch(actions.setModerator(selectedContact));
    dispatch(actions.setModeratorFormFocus(false));
  }
});

function getMaxItems({ allContacts, searchContacts, searchString, listLength = 6 }) {
  const resultLength = searchContacts.length ||
    (searchString ? 1 : 0) ||
    allContacts.length ||
    0;
  return Math.min(resultLength, listLength);
}

function getContact(state, isFocused) {
  const contactModalModerator = _get(state, 'app.contactModal.moderator');
  const oldModerator = _get(state, 'app.contactModal.oldModerator');
  if (contactModalModerator && Object.keys(contactModalModerator).length) {
    return contactModalModerator;
  } else if (oldModerator && Object.keys(oldModerator).length && !isFocused) {
    return oldModerator;
  } else if (!isFocused) {
    return currentUserSelectors.myInfo(state);
  }
  return {};
}

function mapStateToProps(state, ownProps) {
  const searchString = _get(state, 'app.form.moderatorSearch.values.name');
  const isFocused = _get(state, 'app.contactModal.isModeratorFocused');
  const selfResult = currentUserSelectors.myInfo(state);
  const contact = getContact(state, isFocused);
  let allContacts = contactSelectors.potentialModerators(state);
  let searchContacts = searchSelectors.searchModerators(state);
  const isCreate = _get(state, 'app.contactModal.isCreate') || ownProps.isCreate;
  const initialValues = contact;

  if (!_isEmpty(selfResult)) {
    selfResult.isSelf = true;
    allContacts = _reject(allContacts, { id: selfResult.id });
    allContacts.unshift(selfResult);

    // if there is at least one value, also return selfResult as the first value
    if (searchContacts.length) {
      searchContacts = _reject(searchContacts, { contact: { id: selfResult.id } });
      searchContacts.unshift({ contact: selfResult });
    }
  }

  let searchLength;
  if (searchContacts.length === 0) {
    searchLength = allContacts.length;
  } else {
    searchLength = searchContacts.length;
  }

  // Selected contact relates to keyboard nav on dropdowns.
  const selectionIndex = _get(state, 'app.dropdown.selectionIndex');

  let selectedContact;
  if (searchContacts.length) {
    selectedContact = _get(searchContacts[selectionIndex], 'contact');
  } else {
    selectedContact = allContacts[selectionIndex];
  }

  if (searchResults.length !== searchLength) {
    searchResults.length = searchLength;
  }

  let tooltipPosition = ownProps.tooltipPosition || 'right';

  return {
    allContacts,
    maxItems: getMaxItems({
      allContacts, searchContacts, searchString, listLength: ownProps.listLength
    }),
    searchContacts,
    isFocused,
    contact,
    initialValues,
    searchString,
    selfResult,
    searchResults,
    isCreate,
    selectedContact,
    tooltipPosition
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ModeratorSearch);
